import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Yokin = props => {
  return <Dropdown.Static kubunKey='yokin_kbn' {...props} />
}
